import { Avatar, Box, TextField, Typography } from "@mui/material";
import { ReactElement, useState } from "react";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "../../../common/colors";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import SubmitButton from "../../../components/SubmitButton";
import LoadingModal from "../../../components/LoadingModal";
import MessageModal from "../../../components/Models/GreenCity/MessageModal";
import { ErrorMessageModal } from "../../../components/ErrorMessageModal";
import ReimbursementTable from "../../../components/ReimbursementTable";
import style from "./styles";
import appServices from "../../../services/app-services/appServices";

function RejectReimbursement(): ReactElement {
  const groupInfo = useSelector((state: any) => state.gcGroup);
  const navigate = useNavigate();
  const item = useLocation().state.item;
  // const { user } = useSelector((state: any) => state.userAuth);
  const [message, setMessage] = useState<string>("");
  const [openMessageModal, setOpenMessageModal] = useState<boolean>(false)
  const [openErrorMessageModal, setOpenErrorMessageModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState<boolean>(false);

  const handleSubmit = async () => {
    try {
      let body = {
        status: "Rejected",
        rejection_reason: reason,
      };
      setLoading(true);
      let msg = T("reimbursement_succeed_in_reject");
      const res = await appServices.rejectReimbursement(item?.id, body);
      if (res.success) {
        setLoading(false);
        setIsSubmitButtonDisabled(true);
        setMessage(msg);
        setOpenMessageModal(true)
        setTimeout(() => {
          setMessage("");
          navigate(-1);
        }, 3099);
        return true
      } else {
        setLoading(false);
        setMessage(res?.message);
        setOpenErrorMessageModal(true)
        return false
      }
    } catch (error: any) {
      const errorResponse = error?.response?.data?.message
      setLoading(false);
      setMessage(
        typeof errorResponse === "object" ?
          errorResponse.join("\n") :
          errorResponse ?? T("api_unknown_error")
      );
      setOpenErrorMessageModal(true)
      return false
    }
  };

  return (
    <div style={{ paddingTop: 100, margin: 4 }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <LoadingModal visible={loading} />
      <MessageModal
        onContinue={() => {}}
        message={message}
        open={openMessageModal}
        onClose={() => {setOpenMessageModal(false)}}
      />
      <ErrorMessageModal
        messages={[message]}
        open={openErrorMessageModal}
        onClose={() => {setOpenErrorMessageModal(false)}}
      />

      <div style={{ margin: 14 }}>
        <Box sx={style.rowMargin}>
          <Avatar src={groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : ''} sx={{ ...style.avatar, width: "30px" }} />
          <Typography>{groupInfo?.groupName}</Typography>
        </Box>

        <ReimbursementTable reimbursement={item} />
      </div>
      <Typography
        style={{ ...styles.titleSeprator, marginTop: "20px" }}
      >{T("reimbursement_reject_reason")}</Typography>
      <TextField sx={styles.textField} id="outlined-basic" variant="outlined" multiline rows={2} value={reason} onChange={(e) => setReason(e.target.value)} />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <SubmitButton
          style={
            (reason.trim().length === 0 || isSubmitButtonDisabled) ?
            {...styles.button, backgroundColor: colors.farm_gray100} :
            styles.button
          }
          size={"large"}
          variant="contained"
          validate={async () => reason.trim().length !== 0 && !isSubmitButtonDisabled}
          onSubmit={handleSubmit}
        >
          {T("reimbursement_submit_reject")}
        </SubmitButton>
      </Box>
    </div>
  );
}

const styles = {
  titleSeprator: {
    borderBottomColor: colors.farm_green500,
    borderBottomWidth: 2,
    borderBottomStyle: "solid" as const,
    fontSize: 14,
    marginBottom: 6,
  },
  textField: { width: "100%" },
  button: {
    borderRadius: 20,
    backgroundColor: colors.farm_blue200,
    marginTop: "20px",
    width: 220,
  },
};

export default RejectReimbursement;
